import React, { useState, useEffect } from "react";
import NormalLayout from "../../components/layout/NormalLayout";
import axios from "axios";
import {
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
} from "reactstrap";
import Moment from "react-moment";
import { Cookies } from "react-cookie";
import moment from "moment";

const cookies = new Cookies();

function AdminAirSchedule() {
  const [schedules, setSchedules] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [formData, setFormData] = useState({
    aoo: "NZAKL",
    depature_at: "",
    air_schedule_content: "",
  });

  useEffect(() => {
    fetchSchedules();
  }, []);

  const fetchSchedules = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_WHOLESALE_API_URL}/admin/airschedule`,
        {
          headers: {
            Authorization: cookies.get("info").token,
          },
        }
      );

      if (response.data.result === "success") {
        setSchedules(response.data.data);
      }
    } catch (error) {
      console.error("스케줄 데이터를 불러오는데 실패했습니다", error);
      alert("스케줄 데이터를 불러오는데 실패했습니다.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleAdd = () => {
    setSelectedSchedule(null);
    setFormData({
      aoo: "NZAKL",
      depature_at: "",
      air_schedule_content: "",
    });
    setShow(true);
  };

  const handleModify = (schedule) => {
    setSelectedSchedule(schedule);
    setFormData({
      aoo: schedule.aoo || "NZAKL",
      depature_at: moment(schedule.depature_at).format("YYYY-MM-DD"),
      air_schedule_content: schedule.air_schedule_content || "",
    });
    setShow(true);
  };

  const handleDelete = async (id) => {
    const isConfirmed = window.confirm("이 스케줄을 삭제하시겠습니까?");

    if (isConfirmed) {
      try {
        await axios.delete(
          `${process.env.REACT_APP_WHOLESALE_API_URL}/admin/airschedule/${id}`,
          {
            headers: {
              Authorization: cookies.get("info").token,
            },
          }
        );
        fetchSchedules();
      } catch (error) {
        console.error("삭제 중 오류 발생:", error);
        alert("삭제 중 오류가 발생했습니다.");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // 날짜를 timestamp로 변환 (해당 날짜의 00:00:00으로 설정)
      const depatureTimestamp = formData.depature_at
        ? moment(formData.depature_at).format("YYYY-MM-DDTHH:mm:ss")
        : "";

      const submitData = {
        aoo: formData.aoo,
        depature_at: depatureTimestamp,
        air_schedule_content: formData.air_schedule_content,
      };

      if (selectedSchedule) {
        // 수정
        await axios.put(
          `${process.env.REACT_APP_WHOLESALE_API_URL}/admin/airschedule/${selectedSchedule.air_schedule_index}`,
          submitData,
          {
            headers: {
              Authorization: cookies.get("info").token,
            },
          }
        );
      } else {
        // 추가
        await axios.post(
          `${process.env.REACT_APP_WHOLESALE_API_URL}/admin/airschedule`,
          submitData,
          {
            headers: {
              Authorization: cookies.get("info").token,
            },
          }
        );
      }

      setShow(false);
      fetchSchedules();
    } catch (error) {
      console.error("저장 중 오류 발생:", error);
      alert("저장 중 오류가 발생했습니다.");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <NormalLayout>
      <div>
        <h3>항공 스케줄 관리</h3>
      </div>

      <Modal isOpen={show} toggle={() => setShow(!show)} size="lg">
        <ModalHeader toggle={() => setShow(!show)}>
          {selectedSchedule ? "항공 스케줄 수정" : "항공 스케줄 추가"}
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label for="aoo">선적지</Label>
              <Input
                type="text"
                name="aoo"
                id="aoo"
                value={formData.aoo}
                onChange={handleChange}
                required
              />
            </FormGroup>
            <FormGroup>
              <Label for="depature_at">출항 일</Label>
              <Input
                type="date"
                name="depature_at"
                id="depature_at"
                value={formData.depature_at}
                onChange={handleChange}
                required
              />
            </FormGroup>
            <FormGroup>
              <Label for="air_schedule_content">스케줄 내용</Label>
              <Input
                type="textarea"
                name="air_schedule_content"
                id="air_schedule_content"
                rows="5"
                value={formData.air_schedule_content}
                onChange={handleChange}
              />
            </FormGroup>
            <div className="text-end mt-3">
              <Button color="secondary" onClick={() => setShow(false)}>
                취소
              </Button>{" "}
              <Button color="primary" type="submit">
                저장
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>

      <div className="p-3 text-end">
        <Button color="primary" onClick={handleAdd}>
          + 항공 스케줄 추가하기
        </Button>
      </div>

      {isLoading ? (
        <div className="text-center p-5">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">로딩 중...</span>
          </Spinner>
        </div>
      ) : schedules.length > 0 ? (
        <div className="border p-3">
          <Table hover bordered>
            <thead>
              <tr className="table-primary">
                <th className="text-center p-2 border">No</th>
                <th className="text-center p-2 border">선적지</th>
                <th className="text-center p-2 border">출항 일</th>
                <th className="text-center p-2 border">스케줄 내용</th>
                <th className="text-center p-2 border">등록일</th>
                <th className="text-center p-2 border">기능</th>
              </tr>
            </thead>
            <tbody>
              {schedules.map((schedule, idx) => (
                <tr key={schedule.air_schedule_index}>
                  <td className="text-center">{idx + 1}</td>
                  <td className="text-center">{schedule.aoo || "NZAKL"}</td>
                  <td className="text-center">
                    <Moment format="YYYY-MM-DD">{schedule.depature_at}</Moment>
                  </td>
                  <td className="text-center">
                    {schedule.air_schedule_content || "-"}
                  </td>
                  <td className="text-center">
                    <Moment format="YYYY-MM-DD">{schedule.created_at}</Moment>
                  </td>
                  <td className="text-center">
                    <Button
                      size="sm"
                      color="info"
                      onClick={() => handleModify(schedule)}
                      className="me-2"
                    >
                      수정
                    </Button>{" "}
                    <Button
                      size="sm"
                      color="danger"
                      onClick={() => handleDelete(schedule.air_schedule_index)}
                    >
                      삭제
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      ) : (
        <div className="border p-3 text-center">
          등록된 항공 스케줄이 없습니다.
        </div>
      )}
    </NormalLayout>
  );
}

export default AdminAirSchedule;
